// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!./errorBanner.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Page States --- */
.RegistrationForm_loadingState__r\\+IhM,
.RegistrationForm_errorState__IRzUH {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.5rem;
  color: var(--primary-dark-blue);
}

.RegistrationForm_errorState__IRzUH {
  color: #e53e3e;
}

/* --- Main Layout & Container --- */
.RegistrationForm_formLayoutWrapper__RFocp {
  position: relative;
  width: 100%;
  padding: 0 70px;
  box-sizing: border-box;
}

.RegistrationForm_formContainer__aYPkp {
  background-color: var(--neutral-white);
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 800px;
  text-align: left;
  margin: 20px auto;
}

.RegistrationForm_formContent__SIWgK {
  min-height: 450px;
}

/* --- Step Tracker --- */
.RegistrationForm_stepTracker__UL-4Z {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.RegistrationForm_step__y1atq {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.RegistrationForm_step__y1atq.RegistrationForm_activeStep__tKR9R {
  background-color: var(--secondary-bright-blue);
  color: var(--neutral-white);
  transform: scale(1.12);
  box-shadow: 0 0 0 4px rgba(16, 162, 221, 0.18);
}

.RegistrationForm_step__y1atq.RegistrationForm_completedStep__nnx6e {
  background-color: var(--primary-dark-blue);
  color: var(--neutral-white);
}

.RegistrationForm_step__y1atq.RegistrationForm_clickableStep__Q4rGb:hover {
  cursor: pointer;
  transform: scale(1.06);
  box-shadow: 0 2px 8px rgba(31, 42, 92, 0.2);
}

.RegistrationForm_stepConnector__Qqg26 {
  flex-grow: 1;
  height: 4px;
  background-color: #e0e0e0;
  margin: 0 -10px;
  border-radius: 2px;
  transition: background-color 0.3s ease;
}

/* Colored progress fill for connectors before the active step */
.RegistrationForm_stepConnector__Qqg26.RegistrationForm_stepConnectorFilled__G1CV3 {
  background-color: var(--primary-dark-blue);
}

/* --- Navigation Footer --- */
.RegistrationForm_navFooter__BjKxP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.RegistrationForm_backButton__q33Dw,
.RegistrationForm_continueButton__4P2dx {
  min-height: 44px;
  padding: 0 24px;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.RegistrationForm_backButton__q33Dw {
  background-color: transparent;
  border: 1px solid #dbe1e8;
  color: var(--primary-dark-blue);
}

.RegistrationForm_backButton__q33Dw:hover:not(:disabled) {
  background-color: #f0f4f8;
}

.RegistrationForm_continueButton__4P2dx {
  background-color: var(--secondary-bright-blue);
  border: 1px solid var(--secondary-bright-blue);
  color: var(--neutral-white);
  font-weight: 600;
  margin-left: auto;
}

.RegistrationForm_continueButton__4P2dx:hover:not(:disabled) {
  background-color: var(--primary-dark-blue);
  border-color: var(--primary-dark-blue);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.RegistrationForm_backButton__q33Dw:disabled,
.RegistrationForm_continueButton__4P2dx:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Greyed-out (but still clickable) until the step's required fields are
   complete. Clicking surfaces the specific validation errors, then the
   button returns to its active blue once the step is valid. */
.RegistrationForm_continueButtonInactive__Pz1Uv,
.RegistrationForm_continueButtonInactive__Pz1Uv:hover:not(:disabled) {
  background-color: #cbd3dd;
  border-color: #cbd3dd;
  color: var(--neutral-white);
  box-shadow: none;
}

/* --- Error Handling --- */
.RegistrationForm_flashError__E3\\+PT {
  background-color: #fff5f5;
  border: 1px solid #feb2b2;
  color: #c53030;
  padding: 12px 40px 12px 16px;
  border-radius: 8px;
  margin: 0 auto 20px;
  max-width: 800px;
  position: relative;
  font-size: 0.95rem;
  line-height: 1.4;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

.RegistrationForm_inlineError__qkZnZ {
}

.RegistrationForm_inlineErrorClose__pa5o7 {
}

/* --- Responsive Adjustments --- */
@media (max-width: 768px) {
  /* App-shell layout: the form fills the viewport, only .formContent
     scrolls, and the nav footer is locked to the bottom of the screen.
     The full-height flex chain (pageContainer -> mainContent ->
     formLayoutWrapper -> formContainer -> formContent) lives partly in
     LandingPage.module.css; every link needs flex: 1 + min-height: 0. */
  .RegistrationForm_formLayoutWrapper__RFocp {
    padding: 0;
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .RegistrationForm_formContainer__aYPkp {
    box-sizing: border-box;
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 16px 15px 0;
    border-radius: 0;
    box-shadow: none;
  }

  /* Fixed chrome at the top of the card */
  .RegistrationForm_stepTracker__UL-4Z {
    flex-shrink: 0;
    margin-bottom: 20px;
  }

  .RegistrationForm_inlineError__qkZnZ {
    flex-shrink: 0;
  }

  /* The one and only scroll region */
  .RegistrationForm_formContent__SIWgK {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
  }

  /* Locked to the bottom of the screen; content scrolls above it */
  .RegistrationForm_navFooter__BjKxP {
    flex-shrink: 0;
    margin: 0 -15px;
    padding: 12px 15px;
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    background-color: var(--neutral-white);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  }

  .RegistrationForm_continueButton__4P2dx {
    flex: 1 1;
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/RegistrationForm.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;EAC3B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,gEAAgE;AAChE;EACE,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;EAC9C,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;;AAEA;AAEA;;AAEA;AAEA;;AAEA,mCAAmC;AACnC;EACE;;;;wEAIsE;EACtE;IACE,UAAU;IACV,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,wCAAwC;EACxC;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA,mCAAmC;EACnC;IACE,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA,iEAAiE;EACjE;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sDAAsD;IACtD,sCAAsC;IACtC,0CAA0C;EAC5C;;EAEA;IACE,SAAO;IACP,cAAc;EAChB;AACF","sourcesContent":["/* --- Page States --- */\n.loadingState,\n.errorState {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 1.5rem;\n  color: var(--primary-dark-blue);\n}\n\n.errorState {\n  color: #e53e3e;\n}\n\n/* --- Main Layout & Container --- */\n.formLayoutWrapper {\n  position: relative;\n  width: 100%;\n  padding: 0 70px;\n  box-sizing: border-box;\n}\n\n.formContainer {\n  background-color: var(--neutral-white);\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);\n  width: 100%;\n  max-width: 800px;\n  text-align: left;\n  margin: 20px auto;\n}\n\n.formContent {\n  min-height: 450px;\n}\n\n/* --- Step Tracker --- */\n.stepTracker {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.step {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #e0e0e0;\n  color: #999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.step.activeStep {\n  background-color: var(--secondary-bright-blue);\n  color: var(--neutral-white);\n  transform: scale(1.12);\n  box-shadow: 0 0 0 4px rgba(16, 162, 221, 0.18);\n}\n\n.step.completedStep {\n  background-color: var(--primary-dark-blue);\n  color: var(--neutral-white);\n}\n\n.step.clickableStep:hover {\n  cursor: pointer;\n  transform: scale(1.06);\n  box-shadow: 0 2px 8px rgba(31, 42, 92, 0.2);\n}\n\n.stepConnector {\n  flex-grow: 1;\n  height: 4px;\n  background-color: #e0e0e0;\n  margin: 0 -10px;\n  border-radius: 2px;\n  transition: background-color 0.3s ease;\n}\n\n/* Colored progress fill for connectors before the active step */\n.stepConnector.stepConnectorFilled {\n  background-color: var(--primary-dark-blue);\n}\n\n/* --- Navigation Footer --- */\n.navFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.backButton,\n.continueButton {\n  min-height: 44px;\n  padding: 0 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.backButton {\n  background-color: transparent;\n  border: 1px solid #dbe1e8;\n  color: var(--primary-dark-blue);\n}\n\n.backButton:hover:not(:disabled) {\n  background-color: #f0f4f8;\n}\n\n.continueButton {\n  background-color: var(--secondary-bright-blue);\n  border: 1px solid var(--secondary-bright-blue);\n  color: var(--neutral-white);\n  font-weight: 600;\n  margin-left: auto;\n}\n\n.continueButton:hover:not(:disabled) {\n  background-color: var(--primary-dark-blue);\n  border-color: var(--primary-dark-blue);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.backButton:disabled,\n.continueButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Greyed-out (but still clickable) until the step's required fields are\n   complete. Clicking surfaces the specific validation errors, then the\n   button returns to its active blue once the step is valid. */\n.continueButtonInactive,\n.continueButtonInactive:hover:not(:disabled) {\n  background-color: #cbd3dd;\n  border-color: #cbd3dd;\n  color: var(--neutral-white);\n  box-shadow: none;\n}\n\n/* --- Error Handling --- */\n.flashError {\n  background-color: #fff5f5;\n  border: 1px solid #feb2b2;\n  color: #c53030;\n  padding: 12px 40px 12px 16px;\n  border-radius: 8px;\n  margin: 0 auto 20px;\n  max-width: 800px;\n  position: relative;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  z-index: 100;\n}\n\n.inlineError {\n  composes: inlineError from './errorBanner.module.css';\n}\n\n.inlineErrorClose {\n  composes: inlineErrorClose from './errorBanner.module.css';\n}\n\n/* --- Responsive Adjustments --- */\n@media (max-width: 768px) {\n  /* App-shell layout: the form fills the viewport, only .formContent\n     scrolls, and the nav footer is locked to the bottom of the screen.\n     The full-height flex chain (pageContainer -> mainContent ->\n     formLayoutWrapper -> formContainer -> formContent) lives partly in\n     LandingPage.module.css; every link needs flex: 1 + min-height: 0. */\n  .formLayoutWrapper {\n    padding: 0;\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .formContainer {\n    box-sizing: border-box;\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 100%;\n    margin: 0;\n    padding: 16px 15px 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  /* Fixed chrome at the top of the card */\n  .stepTracker {\n    flex-shrink: 0;\n    margin-bottom: 20px;\n  }\n\n  .inlineError {\n    flex-shrink: 0;\n  }\n\n  /* The one and only scroll region */\n  .formContent {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 8px;\n  }\n\n  /* Locked to the bottom of the screen; content scrolls above it */\n  .navFooter {\n    flex-shrink: 0;\n    margin: 0 -15px;\n    padding: 12px 15px;\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n    background-color: var(--neutral-white);\n    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);\n  }\n\n  .continueButton {\n    flex: 1;\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingState": `RegistrationForm_loadingState__r+IhM`,
	"errorState": `RegistrationForm_errorState__IRzUH`,
	"formLayoutWrapper": `RegistrationForm_formLayoutWrapper__RFocp`,
	"formContainer": `RegistrationForm_formContainer__aYPkp`,
	"formContent": `RegistrationForm_formContent__SIWgK`,
	"stepTracker": `RegistrationForm_stepTracker__UL-4Z`,
	"step": `RegistrationForm_step__y1atq`,
	"activeStep": `RegistrationForm_activeStep__tKR9R`,
	"completedStep": `RegistrationForm_completedStep__nnx6e`,
	"clickableStep": `RegistrationForm_clickableStep__Q4rGb`,
	"stepConnector": `RegistrationForm_stepConnector__Qqg26`,
	"stepConnectorFilled": `RegistrationForm_stepConnectorFilled__G1CV3`,
	"navFooter": `RegistrationForm_navFooter__BjKxP`,
	"backButton": `RegistrationForm_backButton__q33Dw`,
	"continueButton": `RegistrationForm_continueButton__4P2dx`,
	"continueButtonInactive": `RegistrationForm_continueButtonInactive__Pz1Uv`,
	"flashError": `RegistrationForm_flashError__E3+PT`,
	"inlineError": `RegistrationForm_inlineError__qkZnZ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["inlineError"]}`,
	"inlineErrorClose": `RegistrationForm_inlineErrorClose__pa5o7 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["inlineErrorClose"]}`
};
export default ___CSS_LOADER_EXPORT___;
